import { makeStyles } from '@material-ui/core/styles';
import { reskinStyles } from 'core/components/theme/theme-variant';

const styles = (theme) => ({
  checkboxContainer: {
    display: 'flex',
    justifyContent: 'left',
    alignItems: 'flex-end'
  },
  left: {
    textAlign: 'start'
  },
  noUnitNumber: {
    margin: 'auto',
    textAlign: 'start'
  },
  secondaryPhoneContainer: {
    border: `3px solid ${theme.colorPalette.white}`,
    borderRadius: 3,
    padding: theme.spacing(2, 0, 2, 5),
    margin: theme.spacing(4, 0),
    // Reskin: a beige inset panel; a white border can't frame anything on the new look's white card.
    ...reskinStyles(theme, theme.cardStyles.inset)
  },
  textCheckbox: {
    marginLeft: '5px'
  },
  link: {
    color: theme.colorPalette.orange_50
  },
  paddingBottom: {
    paddingBottom: theme.spacing(4)
  }
});

export default makeStyles(styles);
